import Fieldset from "components/form/Fieldset";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import TextInput from "components/form/input/TextInput";

export default function ApontamentoObservacao() {
    return (
        <Fieldset label="Observação" fullWidth>
            <FormContent>
                <FormRow>
                    <TextInput name="observacao" multiline rows={4} />
                </FormRow>
            </FormContent>
        </Fieldset>
    );
}
